import axios from 'axios'

export const resetPassword = async (token, password, confirmPassword) => {
  const BASE_URL =
    process.env.REACT_APP_API_BASE_URL || 'https://pro.vibelinksapp.com/api'
  try {
    const response = await axios.post(`${BASE_URL}/reset-password`, {
      token,
      password,
      confirm_password: confirmPassword
    })
    return response.data
  } catch (err) {
    return {
      success: false,
      message: 'Failed to reset password'
    }
  }
}
